export enum Status {
  Original = 'original',
  Translating = 'translating',
  Translated = 'translated',
}
